namespace TabAurous.Inventory {
    export interface SKUSplittingRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        VoucherNo?: string;
        UserId?: number;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: SKUSplittingDetailsRow[];
        CommonItemDetails?: SKUSplittingItemsRow[];
        PostingDate?: string;
        IsPosted?: boolean;
        CurrencyId?: number;
        ExchRate?: number;
        Username?: string;
    }

    export namespace SKUSplittingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.SKUSplitting';
        export const deletePermission = 'Inventory:SKUSplitting:Delete';
        export const insertPermission = 'Inventory:SKUSplitting:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:SKUSplitting:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            VoucherNo = "VoucherNo",
            UserId = "UserId",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details",
            CommonItemDetails = "CommonItemDetails",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            Username = "Username"
        }
    }
}
